module.exports = __webpack_public_path__ + "img/bgc.1e6dd032.png";